// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/login/v1/login.v1.proto (package no.jotta.openapi.login.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { Void } from "../../void_pb.js";
import { Challenges, Credentials } from "../../credentials_pb.js";
/**
 * @generated from message no.jotta.openapi.login.v1.LoggedIn
 */
export class LoggedIn extends Message {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string auto_login_code = 2;
     */
    autoLoginCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.LoggedIn";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "auto_login_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new LoggedIn().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LoggedIn().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LoggedIn().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LoggedIn, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.StartDeviceLoginRequest
 */
export class StartDeviceLoginRequest extends Message {
    /**
     * @generated from field: string brand_code = 1;
     */
    brandCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.StartDeviceLoginRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new StartDeviceLoginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartDeviceLoginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartDeviceLoginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartDeviceLoginRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.StartDeviceLoginResponse
 */
export class StartDeviceLoginResponse extends Message {
    /**
     * @generated from field: string login_code = 1;
     */
    loginCode = "";
    /**
     * @generated from field: string login_id = 2;
     */
    loginId = "";
    /**
     * @generated from field: string public_approve_url = 3;
     */
    publicApproveUrl = "";
    /**
     * @generated from field: string private_approve_url = 4;
     */
    privateApproveUrl = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.StartDeviceLoginResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "login_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "login_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "public_approve_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "private_approve_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new StartDeviceLoginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartDeviceLoginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartDeviceLoginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartDeviceLoginResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ConfirmDeviceLoginRequest
 */
export class ConfirmDeviceLoginRequest extends Message {
    /**
     * @generated from field: string login_id = 1;
     */
    loginId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ConfirmDeviceLoginRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "login_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ConfirmDeviceLoginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmDeviceLoginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmDeviceLoginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmDeviceLoginRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ConfirmDeviceLoginResponse
 */
export class ConfirmDeviceLoginResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.login.v1.ConfirmDeviceLoginResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ConfirmDeviceLoginResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "logged_in", kind: "message", T: LoggedIn, oneof: "result" },
        { no: 2, name: "pending", kind: "message", T: ConfirmDeviceLoginResponse_Pending, oneof: "result" },
        { no: 3, name: "failed", kind: "message", T: ConfirmDeviceLoginResponse_Failed, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new ConfirmDeviceLoginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmDeviceLoginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmDeviceLoginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmDeviceLoginResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ConfirmDeviceLoginResponse.Pending
 */
export class ConfirmDeviceLoginResponse_Pending extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ConfirmDeviceLoginResponse.Pending";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ConfirmDeviceLoginResponse_Pending().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmDeviceLoginResponse_Pending().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmDeviceLoginResponse_Pending().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmDeviceLoginResponse_Pending, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ConfirmDeviceLoginResponse.Failed
 */
export class ConfirmDeviceLoginResponse_Failed extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ConfirmDeviceLoginResponse.Failed";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ConfirmDeviceLoginResponse_Failed().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmDeviceLoginResponse_Failed().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmDeviceLoginResponse_Failed().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmDeviceLoginResponse_Failed, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.FederatedLoginRequest
 */
export class FederatedLoginRequest extends Message {
    /**
     * @generated from field: string federation_token = 1;
     */
    federationToken = "";
    /**
     * @generated from field: string brand_code = 2;
     */
    brandCode = "";
    /**
     * @generated from field: string login_token = 3;
     */
    loginToken = "";
    /**
     * @generated from field: bytes token = 4;
     */
    token = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.FederatedLoginRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "federation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "login_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new FederatedLoginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FederatedLoginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FederatedLoginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FederatedLoginRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.FederatedLoginResponse
 */
export class FederatedLoginResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.login.v1.FederatedLoginResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.FederatedLoginResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "result" },
        { no: 2, name: "not_linked", kind: "message", T: FederatedLoginResponse_NotLinked, oneof: "result" },
        { no: 3, name: "login_expired", kind: "message", T: Void, oneof: "result" },
        { no: 4, name: "login_failed", kind: "message", T: Void, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new FederatedLoginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FederatedLoginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FederatedLoginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FederatedLoginResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.FederatedLoginResponse.NotLinked
 */
export class FederatedLoginResponse_NotLinked extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.FederatedLoginResponse.NotLinked";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new FederatedLoginResponse_NotLinked().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FederatedLoginResponse_NotLinked().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FederatedLoginResponse_NotLinked().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FederatedLoginResponse_NotLinked, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.EmailLoginRequest
 */
export class EmailLoginRequest extends Message {
    /**
     * @generated from field: string email = 1;
     */
    email = "";
    /**
     * @generated from field: no.jotta.openapi.Credentials credentials = 2;
     */
    credentials;
    /**
     * @generated from field: string login_token = 3;
     */
    loginToken = "";
    /**
     * @generated from field: string brand_code = 4;
     */
    brandCode = "";
    /**
     * @generated from field: bytes token = 5;
     */
    token = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.EmailLoginRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "credentials", kind: "message", T: Credentials },
        { no: 3, name: "login_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new EmailLoginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmailLoginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmailLoginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmailLoginRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.EmailLoginResponse
 */
export class EmailLoginResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.login.v1.EmailLoginResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.EmailLoginResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges, oneof: "result" },
        { no: 3, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "result" },
        { no: 4, name: "login_expired", kind: "message", T: Void, oneof: "result" },
        { no: 5, name: "login_failed", kind: "message", T: Void, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new EmailLoginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmailLoginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmailLoginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmailLoginResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.PhoneNumberLoginRequest
 */
export class PhoneNumberLoginRequest extends Message {
    /**
     * phone_number must be a fully qualified phone number with an IDD prefix, i.e. '004781549300'.
     *
     * @generated from field: string phone_number = 1;
     */
    phoneNumber = "";
    /**
     * @generated from field: no.jotta.openapi.Credentials credentials = 2;
     */
    credentials;
    /**
     * @generated from field: string login_token = 3;
     */
    loginToken = "";
    /**
     * @generated from field: string brand_code = 4;
     */
    brandCode = "";
    /**
     * @generated from field: bytes token = 5;
     */
    token = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.PhoneNumberLoginRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "credentials", kind: "message", T: Credentials },
        { no: 3, name: "login_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new PhoneNumberLoginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhoneNumberLoginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhoneNumberLoginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhoneNumberLoginRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.PhoneNumberLoginResponse
 */
export class PhoneNumberLoginResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.login.v1.PhoneNumberLoginResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.PhoneNumberLoginResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges, oneof: "result" },
        { no: 3, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "result" },
        { no: 4, name: "login_expired", kind: "message", T: Void, oneof: "result" },
        { no: 5, name: "login_failed", kind: "message", T: Void, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new PhoneNumberLoginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PhoneNumberLoginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PhoneNumberLoginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PhoneNumberLoginResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.StartPasswordResetRequest
 */
export class StartPasswordResetRequest extends Message {
    /**
     * @generated from field: string brand_code = 1;
     */
    brandCode = "";
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    /**
     * @generated from field: bytes token = 3;
     */
    token = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.StartPasswordResetRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new StartPasswordResetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartPasswordResetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartPasswordResetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartPasswordResetRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.StartPasswordResetResponse
 */
export class StartPasswordResetResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.StartPasswordResetResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new StartPasswordResetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StartPasswordResetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StartPasswordResetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StartPasswordResetResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.CheckPasswordResetRequest
 */
export class CheckPasswordResetRequest extends Message {
    /**
     * @generated from field: string reset_key = 1;
     */
    resetKey = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.CheckPasswordResetRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "reset_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckPasswordResetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPasswordResetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPasswordResetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPasswordResetRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.CheckPasswordResetResponse
 */
export class CheckPasswordResetResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.login.v1.CheckPasswordResetResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.CheckPasswordResetResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "valid", kind: "message", T: CheckPasswordResetResponse_Valid, oneof: "result" },
        { no: 2, name: "redirect", kind: "message", T: CheckPasswordResetResponse_Redirect, oneof: "result" },
        { no: 3, name: "invalid", kind: "message", T: CheckPasswordResetResponse_Invalid, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new CheckPasswordResetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPasswordResetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPasswordResetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPasswordResetResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.CheckPasswordResetResponse.Valid
 */
export class CheckPasswordResetResponse_Valid extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.CheckPasswordResetResponse.Valid";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckPasswordResetResponse_Valid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPasswordResetResponse_Valid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPasswordResetResponse_Valid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPasswordResetResponse_Valid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.CheckPasswordResetResponse.Redirect
 */
export class CheckPasswordResetResponse_Redirect extends Message {
    /**
     * @generated from field: string url = 1;
     */
    url = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.CheckPasswordResetResponse.Redirect";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CheckPasswordResetResponse_Redirect().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPasswordResetResponse_Redirect().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPasswordResetResponse_Redirect().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPasswordResetResponse_Redirect, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.CheckPasswordResetResponse.Invalid
 */
export class CheckPasswordResetResponse_Invalid extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.CheckPasswordResetResponse.Invalid";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CheckPasswordResetResponse_Invalid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckPasswordResetResponse_Invalid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckPasswordResetResponse_Invalid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckPasswordResetResponse_Invalid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ResetPasswordRequest
 */
export class ResetPasswordRequest extends Message {
    /**
     * @generated from field: string reset_key = 1;
     */
    resetKey = "";
    /**
     * @generated from field: string password = 2;
     */
    password = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ResetPasswordRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "reset_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ResetPasswordRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResetPasswordRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResetPasswordRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResetPasswordRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ResetPasswordResponse
 */
export class ResetPasswordResponse extends Message {
    /**
     * @generated from field: optional no.jotta.openapi.login.v1.LoggedIn logged_in = 1;
     */
    loggedIn;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ResetPasswordResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "logged_in", kind: "message", T: LoggedIn, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new ResetPasswordResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResetPasswordResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResetPasswordResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResetPasswordResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ExchangeInstallationCodeRequest
 */
export class ExchangeInstallationCodeRequest extends Message {
    /**
     * @generated from field: string brand_code = 1;
     */
    brandCode = "";
    /**
     * @generated from field: string installation_code = 2;
     */
    installationCode = "";
    /**
     * @generated from field: bytes token = 3;
     */
    token = new Uint8Array(0);
    /**
     * @generated from field: optional string login_token = 4;
     */
    loginToken;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ExchangeInstallationCodeRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "installation_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 4, name: "login_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new ExchangeInstallationCodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExchangeInstallationCodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExchangeInstallationCodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExchangeInstallationCodeRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ExchangeInstallationCodeResponse
 */
export class ExchangeInstallationCodeResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.login.v1.ExchangeInstallationCodeResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ExchangeInstallationCodeResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "installation", kind: "message", T: ExchangeInstallationCodeResponse_Installation, oneof: "result" },
        { no: 2, name: "not_found", kind: "message", T: ExchangeInstallationCodeResponse_NotFound, oneof: "result" },
        { no: 3, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new ExchangeInstallationCodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExchangeInstallationCodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExchangeInstallationCodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExchangeInstallationCodeResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ExchangeInstallationCodeResponse.Installation
 */
export class ExchangeInstallationCodeResponse_Installation extends Message {
    /**
     * @generated from field: no.jotta.openapi.login.v1.LoggedIn logged_in = 1;
     */
    loggedIn;
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ExchangeInstallationCodeResponse.Installation";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "logged_in", kind: "message", T: LoggedIn },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ExchangeInstallationCodeResponse_Installation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExchangeInstallationCodeResponse_Installation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExchangeInstallationCodeResponse_Installation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExchangeInstallationCodeResponse_Installation, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.ExchangeInstallationCodeResponse.NotFound
 */
export class ExchangeInstallationCodeResponse_NotFound extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.ExchangeInstallationCodeResponse.NotFound";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ExchangeInstallationCodeResponse_NotFound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExchangeInstallationCodeResponse_NotFound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExchangeInstallationCodeResponse_NotFound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExchangeInstallationCodeResponse_NotFound, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.GetLoginRequest
 */
export class GetLoginRequest extends Message {
    /**
     * @generated from field: string login_token = 1;
     */
    loginToken = "";
    /**
     * @generated from field: string brand_code = 2;
     */
    brandCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.GetLoginRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "login_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetLoginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLoginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLoginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLoginRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.GetLoginResponse
 */
export class GetLoginResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.login.v1.GetLoginResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.GetLoginResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "login", kind: "message", T: GetLoginResponse_Login, oneof: "result" },
        { no: 2, name: "not_found", kind: "message", T: GetLoginResponse_NotFound, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new GetLoginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLoginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLoginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLoginResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.GetLoginResponse.NotFound
 */
export class GetLoginResponse_NotFound extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.GetLoginResponse.NotFound";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetLoginResponse_NotFound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLoginResponse_NotFound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLoginResponse_NotFound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLoginResponse_NotFound, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.login.v1.GetLoginResponse.Login
 */
export class GetLoginResponse_Login extends Message {
    /**
     * @generated from field: string client_id = 1;
     */
    clientId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.login.v1.GetLoginResponse.Login";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "client_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetLoginResponse_Login().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLoginResponse_Login().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLoginResponse_Login().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLoginResponse_Login, a, b);
    }
}
